/**
 * 그룹 트리 끌어다 놓기 규약(설계서 §14.20) — 무엇을 끌고 있는지를 dataTransfer 에 싣고 읽는다.
 *
 * 전용 MIME 을 쓰는 이유: dragover 중에는 데이터를 읽을 수 없고 **형식 이름만** 보인다. 전용 형식이어야
 * "트리 항목을 끄는 중일 때만 그룹 머리가 받아들인다" 를 판정할 수 있다(파일·글자를 끌어올 때는 반응하지 않게).
 */

export const TREE_DRAG_MIME = 'application/x-rs-tree-item';

/** 끌 수 있는 것: 관리 기기 · 공유 ID 항목 · 그룹. */
export type TreeDragKind = 'agent' | 'entry' | 'group';

export interface TreeDragItem {
  kind: TreeDragKind;
  id: string;
}

const KINDS: readonly TreeDragKind[] = ['agent', 'entry', 'group'];

/** dataTransfer 에 실을 문자열. */
export function encodeDrag(item: TreeDragItem): string {
  return JSON.stringify(item);
}

/** 놓을 때 읽기 — 형식이 다르거나 깨졌으면 null(다른 앱에서 끌어온 것 등). */
export function decodeDrag(raw: string | null | undefined): TreeDragItem | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<TreeDragItem>;
    if (v && typeof v.id === 'string' && v.id && KINDS.includes(v.kind as TreeDragKind)) {
      return { kind: v.kind as TreeDragKind, id: v.id };
    }
  } catch {
    /* 깨진 값 */
  }
  return null;
}

/** dragover 판정 — 트리 항목을 끄는 중인가(형식 이름만 본다). */
export function isTreeDrag(types: readonly string[] | DOMStringList | null | undefined): boolean {
  if (!types) return false;
  return Array.from(types as ArrayLike<string>).includes(TREE_DRAG_MIME);
}
